<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="优惠券名称">
        <Input
          style="width:200px"
          placeholder="请输入优惠券名称关键字"
          v-model="searchCondition.name"
          clearable
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/coupon/not/grant"
        method="get"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
      ></Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseSelect",
  data() {
    return {
      columns: [
        {
          title: "优惠券名称",
          key: "name",
          align: "center"
        },
        {
          title: "优惠范围",
          align: "center",
          key: "scope_type_name"
        }
      ],
      selectList: [],
      searchCondition: {
        name: "",
        receive_type: 2
      }
    };
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: "multi"
    }
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        switch (i.scope_type) {
          case 1:
            if (i.dis_type == 1) {
              i.scope_type_name = "全部（班课）";
            } else {
              i.scope_type_name = "全部（一对一）";
            }
            break;
          case 2:
            if (i.dis_type == 1) {
              i.scope_type_name = "指定课程分类";
            } else {
              i.scope_type_name = "指定一对一讲师";
            }
            break;
          case 3:
            i.scope_type_name = "指定课程";
            break;
        }
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>